<script setup lang="ts">
import { mdiChevronDown } from '@mdi/js'
import type { Validate } from '@/shared/types/validation.types'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  active?: boolean
  disabled?: boolean
  validation?: Validate
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <SvgIcon
    :path="mdiChevronDown"
    class="transition linear duration-300"
    :class="[
      active ? 'rotate-180' : 'rotate-0',
      disabled ? 'fill-gray-400' : 'fill-gray-700 dark:fill-white',
    ]"
    v-bind="$attrs"
  />
</template>
